// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__eH_C8"};